module.exports = __webpack_public_path__ + "img/andriod-chrome_web_li.51cf0dd8.webp";